import toolbar from './toolbar'

const bars =
{
    toolbar
};

export default bars ;
